__turbopack_context__.v({
  "appDownloadBadge": "styles-module__YtP2DG__appDownloadBadge",
  "appDownloadBadgeBody": "styles-module__YtP2DG__appDownloadBadgeBody",
  "appDownloadBadgeText": "styles-module__YtP2DG__appDownloadBadgeText",
  "appDownloadBadgeTitle": "styles-module__YtP2DG__appDownloadBadgeTitle",
  "reviewsText": "styles-module__YtP2DG__reviewsText",
  "reviewsWrapper": "styles-module__YtP2DG__reviewsWrapper",
});
